//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';
import FeaturedIn from '~/components/FeaturedIn.vue';
import { windowResizeMixin } from '~/mixins/resize';

export default {
  name: 'Kickboxing_AboveTheFold',
  mixins: [windowResizeMixin],
  components: {
    FCImage,
    FeaturedIn,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  computed: {
    imageDimensions() {
      const width = this.mixinResize.initialWidth;
      const height = Math.ceil(this.mixinResize.currentHeight * 0.9);

      return {
        width,
        height,
      };
    },
  },
};
